import React from 'react';
import { Navigate } from 'react-router';
import { CircularProgress } from '@mui/material';
import { useCustomer } from '@features/Profile/hooks/use-customer.ts';

const withProtectedRoute = (Component: React.FC): React.FC => {

  return () => {
    const { data: customer, isLoading } = useCustomer();
    if(isLoading){
      return  <CircularProgress />
    }
    return customer || import.meta.env.DEV ? <Component /> : <Navigate to="/" replace />;
  };
};

export default withProtectedRoute;
